import React, { ReactNode } from 'react';
import { Grid, styled } from '@mui/material';
import QueryFilterDrawer from '../../components/Filters/QueryFilterDrawer';

const classesPrefix = 'basePage';

const classes = {
    container: `${classesPrefix}-container`,
};

const StyledGrid = styled(Grid)(() => {
    return {
        [`&.${classes.container}`]: {
            minHeight: '100%',
            flexWrap: 'nowrap',
        },
    };
});

const BasePage = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <StyledGrid
            container
            className={classes.container}
            justifyContent='flex-start'
            direction='column'
            id='base-page-container'
        >
            {children}
            <QueryFilterDrawer />
        </StyledGrid>
    );
};

export default BasePage;
